import MovieDetail from "./MovieDetail";

export default MovieDetail;
